import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { resource } from "@util/resource";

export interface PosOrderLinePayload {
  id?: number;
  productId?: string;
  product?: { id: string };
  quantity: number;
  amountCents: number;
  amountDiscountCents?: number;
  unitDiscountCents?: number;
  vat?: number;
  type: string;
  nameIt?: string;
  nameEn?: string;
  descriptionIt?: string;
  descriptionEn?: string;
  barcode?: string;
  sku?: string;
  rowDiscountType?: string;
  rowDiscountValue?: number;
}

export interface PosOrderTotalsPayload {
  subtotalGrossCents?: number;
  subtotalVatCents?: number;
  subtotalDiscountedCents?: number;
  shipmentCostCents?: number;
  shipmentVatCents?: number;
  discountCents?: number;
  totalCents?: number;
}

export interface PosOrderPayload {
  code?: string;
  quantity?: number;
  amountCents: number;
  amountDiscountCents?: number;
  amountShipmentCents?: number;
  date?: string;
  notes?: string;
  address?: string;
  city?: string;
  province?: string;
  zipcode?: string;
  country?: string;
  countryId?: number;
  shippingName?: string;
  shippingPhone?: string;
  senderEmail?: string;
  contactId?: number;
  billingName?: string;
  billingAddress?: string;
  billingCity?: string;
  billingProvince?: string;
  billingZipcode?: string;
  billingCountry?: string;
  billingCountryId?: number;
  wineryChannel: string;
  status: string;
  paymentType: string;
  couponCode?: string;
  couponType?: string;
  couponDiscountCents?: number;
  couponDiscountPercent?: number;
  deliveryMode?: string;
  data?: Record<string, unknown>;
  products: PosOrderLinePayload[];
  totals?: PosOrderTotalsPayload;
}

export interface PosContextPayload {
  accountId?: string;
  operatorId?: string;
  operatorName?: string;
  cartId?: string;
  appVersion?: string;
}

export interface PosOrderImportRequest {
  fiskalyEnabled?: boolean;
  posContext?: PosContextPayload;
  metadata?: Record<string, unknown>;
  order: PosOrderPayload;
}

export interface PosOrderUpdateResponse {
  orderId: number;
  orderTotals?: Record<string, unknown>;
  vatBreakdown?: unknown;
}

@Injectable({
  providedIn: "root",
})
export class PosOrdersService {
  updatePosOrder(orderId: number, body: PosOrderImportRequest): Observable<PosOrderUpdateResponse> {
    return resource("crm://pos-orders/id").params({ id: orderId }).put<PosOrderUpdateResponse>(body);
  }
}
